import React from 'react';
import { colors } from '@styleseat/brand';

export type VideoPlayIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export function VideoPlayIcon({
  width = 21,
  height = 26,
  color = colors.whiteWash,
}: VideoPlayIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 13L7.65417e-07 25.1244L1.82536e-06 0.875644L21 13Z"
        fill={color}
      />
    </svg>
  );
}
